import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '../views/index/HomePage.vue'

Vue.use(VueRouter)

const routes = [
      // 路由重新定向
    {
        path: '/',
        // redirect: "/index",
        redirect: () => {
            // 这里写你的登录态判断，例如从localStorage/vuex读取
            const isLogin = !!localStorage.getItem('token')
            if (isLogin) {
                // return '/index'
                return '/order'
            } else {
                return '/login'
            }
          }
    },
    {
        path: '/login',
        name: 'loginPage',
        component: () => import("@/views/login/loginPage.vue"),
    },
    // 首页
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        
        children:[
            {
                path: '/index',
                name: '首页',
                component: () => import("@/views/index/indexPage.vue"),
            },{
                path: '/information',
                // name: 'informationPage',
                name: '信息大厅',
                component: () => import("@/views/info/informationPage.vue"),
            },{
                path: '/userInfo',
                // name: 'userInfoPage',
                name: '个人信息',
                component: () => import("@/views/index/userInfoPage.vue"),
            },{
                path: '/order',
                name: '接单大厅',
                component: () => import("@/views/order/orderPage.vue"),
            },{
                path: '/orderDetail',
                name: '订单详情',
                component: () => import("@/views/order/orderDetailPage.vue"),
            },{
                path: '/multipleCabinets',
                name: '订单详情',
                component: () => import("@/views/order/multipleCabinetsPage.vue"),
            },{
                path: '/orderDetailRead',
                name: '订单详情',
                component: () => import("@/views/order/orderDetailReadPage.vue"),
            },{
                path: '/multipleCabinetsRead',
                name: '子订单列表',
                component: () => import("@/views/order/multipleCabinetsReadPage.vue"),
            },{
                path: '/carrier_order',
                name: '承运订单',
                component: () => import("@/views/order/carrierOrderPage.vue"),
            },{
                path: '/carrierOrderDetail',
                name: '订单详情',
                component: () => import("@/views/order/orderDetailPage.vue"),
            },{
                path: '/delivery',
                name: '在线发货',
                component: () => import("@/views/delivery/deliveryPage.vue"),
            },{
                path: '/shipping_order',
                name: '发货订单',
                component: () => import("@/views/delivery/shippingOrderPage.vue"),
            },{
                path: '/shippingOrderDetail',
                name: '发货订单',
                component: () => import("@/views/delivery/orderDetailPage.vue"),
            },{
                path: '/driverManagement',
                name: '司机管理',
                component: () => import("@/views/management/driverPage.vue"),
            },{
                path: '/driverDetail',
                name: '司机详情',
                component: () => import("@/views/management/driverDetailPage.vue"),
            },{
                path: '/dispatcherManagement',
                name: '调度员管理',
                component: () => import("@/views/management/dispatcherPage.vue"),
            },{
                path: '/dispatcherDetail',
                name: '调度员详情',
                component: () => import("@/views/management/dispatcherDetailPage.vue"),
            },{
                path: '/memberCenter',
                name: '会员中心',
                component: () => import("@/views/vip/vipCenter.vue"),
            },{
                path: '/wallet',
                name: '车队钱包',
                component: () => import("@/views/wallet/walletPage.vue"),
            },{
                path: '/addressBook',
                name: '地址薄',
                component: () => import("@/views/other/addressBookPage.vue"),
            },{
                path: '/contacts',
                name: '通讯录',
                component: () => import("@/views/other/contactsPage.vue"),
            },{
                path: '/commonHeadRaising',
                name: '常用抬头',
                component: () => import("@/views/other/commonHeadRaisingPage.vue"),
            },{
                path: '/invoiceRecord',
                name: '开票记录',
                component: () => import("@/views/other/invoiceRecordPage.vue"),
            },{
                path: '/systemNotification',
                name: '系统通知',
                component: () => import("@/views/message/systemMessagePage.vue"),
            },{
                path: '/orderNotification',
                name: '订单通知',
                component: () => import("@/views/message/orderMessagePage.vue"),
            },{
                path: '/messageNotification',
                name: '留言通知',
                component: () => import("@/views/message/noteMessagePage.vue"),
            },{
                path: '/messageDetail',
                name: '留言通知详情',
                component: () => import("@/views/message/messageDetailPage.vue"),
            }
        ]
    },
]

const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// meta: {
  //   requiresAuth: true,
  //   content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
// },


const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

router.beforeEach((to, from, next) => {
    // to  去哪个页面
    // form  来自哪个页面
    console.log(to,from);
//     const isLogin = localStorage.getItem('isLogin')
//     console.log('路由',to,from);

//     if ( !isLogin ) {
//         next('/') // 未登录则重定向到登录页面
//     } else {
        next()
//     }
})

router.afterEach((to, from) => {
  // 在路由切换后滚动到页面顶部
    console.log('路由切换',to.path,from.path);
    if (to.path !== from.path) {
        window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
    }
})



export default router
